import { ProjectScript } from 'js/reducers/projectScripts';

import { fetchWithReAuth } from '../../requestLimiter';

import { AppServiceResponse, getObject, getOptions, getServicesUrl, validateResponse } from './helpers';

import { appServices } from '.';

const baseUrl = getServicesUrl();

export const getProjectScriptsByProjectId = async (projectId: number): Promise<ProjectScript[]> => {
  const url = `${baseUrl}v2/project-script?projectId=${projectId}`;
  const options = getOptions('GET');
  const scripts = await fetchWithReAuth(url, appServices.exchangeCognitoTokenForSparkolToken, options)
    .then(r => validateResponse<AppServiceResponse>(r as AppServiceResponse, `Error fetching your projects.`))
    .then(r => getObject<ProjectScript[]>(r));

  return scripts;
};

export const createProjectScript = async (script: Partial<ProjectScript>): Promise<ProjectScript> => {
  const url = `${baseUrl}v2/project-script`;
  const options = getOptions('POST', JSON.stringify(script));
  const newScript = await fetchWithReAuth(url, appServices.exchangeCognitoTokenForSparkolToken, options)
    .then(r => validateResponse<AppServiceResponse>(r as AppServiceResponse, `Error creating your script.`))
    .then(r => getObject<ProjectScript>(r));

  return newScript;
};

export const updateProjectScript = async (script: Partial<ProjectScript>): Promise<ProjectScript> => {
  if (!script.id) {
    throw new Error('Script ID is required for updating a project script.');
  }

  const url = `${baseUrl}v2/project-script/${script.id}`;
  const options = getOptions('PUT', JSON.stringify(script));
  const updatedScript = await fetchWithReAuth(url, appServices.exchangeCognitoTokenForSparkolToken, options)
    .then(r => validateResponse<AppServiceResponse>(r as AppServiceResponse, `Error updating your script.`))
    .then(r => getObject<ProjectScript>(r));

  return updatedScript;
};

export const deleteProjectScript = async (scriptId: number): Promise<void> => {
  const url = `${baseUrl}v2/project-script/${scriptId}`;
  const options = getOptions('DELETE');
  await fetchWithReAuth(url, appServices.exchangeCognitoTokenForSparkolToken, options)
    .then(r => validateResponse<AppServiceResponse>(r as AppServiceResponse, `Error deleting your script.`));
};
